import React from 'react';

import { getFaviconForTechnology } from 'pages/explore/explore.controller';

import { SelectOption } from 'types/selectOption';

import { DataExportDimensionId } from '..';

import { Dimension, StandardDimension, TagOnlyDimension, TagVariableDimension } from './viewModels';

export function dimensionToSelectOption(dimension: Dimension): SelectOption {
  return {
    value: dimension.id,
    label: dimension.friendlyName,
    group: dimension.group ?? 'Dimensions',
    icon:
      dimension.source === 'tags.variableConfigs' && dimension.tagOnly ? (
        <img width={20} src={getFaviconForTechnology(dimension.friendlyName, true)} />
      ) : undefined,
  };
}

export function dimensionSort(a: SelectOption | Dimension, b: SelectOption | Dimension) {
  const groupA = a.group ?? 'Dimensions';
  const groupB = b.group ?? 'Dimensions';

  const labelA = 'label' in a ? a.label : a.friendlyName;
  const labelB = 'label' in b ? b.label : b.friendlyName;

  if (groupA === groupB) {
    return labelA.localeCompare(labelB);
  } else {
    return groupA.localeCompare(groupB);
  }
}

export function getDimensionId(
  dimension: StandardDimension | TagOnlyDimension | TagVariableDimension
): DataExportDimensionId {
  if (dimension.source === 'dimensions') {
    return dimension.dimensionId;
  } else {
    if (dimension.tagOnly) {
      return `tag.${dimension.tagId}` as DataExportDimensionId;
    } else {
      return `tag.${dimension.tagId}.${dimension.variableId}.${dimension.variablePath}` as DataExportDimensionId;
    }
  }
}
